import { FETCH_REVIEWS, CREATE_REVIEW, CREATE_REPLY, REQUEST_REVIEWS } from '../actions/Types'
const categoryReviewReducer = (state={loading: false, data: []}, action) => {
    switch(action.type){
        case FETCH_REVIEWS:
            return {loading: false, data: action.payload}
        case REQUEST_REVIEWS:
            return {loading: true, data: []}
        case CREATE_REVIEW:
            let new_state = {loading: false, data: [...state.data, action.payload]}
            return new_state
        case CREATE_REPLY:
            const newState = state.data.map(x => {
                if (x.id === action.payload.parent){
                    if (x.added_replies){
                        x.added_replies.push(action.payload)
                    }
                    else {
                        x.added_replies = [action.payload]
                    }
                }
                return x
            })

            return {loading: false, data: newState}
        default:
            return state
    }

}

export default categoryReviewReducer